<template>
  <span v-if="bundle?.Labels?.at(0)?.Text" class="sr-only">
    Kampanj: {{ bundle?.Labels?.at(0)?.Text }}.
  </span>
</template>

<script lang="ts" setup>
import type { AggregatedBundlePriceDto } from '~/models/ListingProduct.api.model';

interface Props {
  bundle?: AggregatedBundlePriceDto;
}

defineProps<Props>();
</script>
